var isObject = require('./_is-object');
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};


//////////////////
// WEBPACK FOOTER
// /app/node_modules/core-js/library/modules/_an-object.js
// module id = 118
// module chunks = 0